<div class="cmdk-cmdprev">
  <div class="cmdk-cmdprev__head">
    <span class="cmdk-cmdprev__glyph" aria-hidden="true">
      @if (item().command.id === 'nav:flow') {
        <im-flow-mark variant="ink" [size]="22" />
      } @else {
        <paper-icon [name]="item().command.icon" [size]="22" />
      }
    </span>
    <div class="cmdk-cmdprev__ident">
      <h3 class="cmdk-cmdprev__title">{{ item().title }}</h3>
      <p class="cmdk-cmdprev__kind">{{ kindLabel() }}</p>
    </div>
  </div>

  <p class="cmdk-cmdprev__desc">{{ description() }}</p>

  @if (shortcutKeys(); as keys) {
    <p class="cmdk-cmdprev__shortcut">
      <span>{{ triggerLabel() }}</span>
      <paper-kbd [keys]="keys" [mod]="usesModifier()" size="md" />
    </p>
  }

  <div class="cmdk-cmdprev__actions">
    <paper-button
      intent="primary"
      size="sm"
      data-testid="cmdk-preview-run"
      (click)="activated.emit()">
      {{ runLabel() }}
    </paper-button>
    <paper-kbd keys="↵" label="Enter" size="sm" />
  </div>
</div>
